/*
  In-store assembly add-on (see snippets/assembly-addon.liquid, cart-item-assembly.liquid).
    - PDP: show the checkbox only for complete-bike variants; when checked,
      theme.AjaxProduct sends bike + assembly in one /cart/add.js request
      (payload built by CinelliAssembly.payload).
    - Cart: "Add in-store assembly" buttons, and [data-assembly-cap] markers
      that lower an assembly line's quantity when its bikes were removed.
*/
(function() {
  var selectors = {
    addon: '[data-assembly-addon]',
    checkbox: '[data-assembly-addon-checkbox]',
    cartAdd: '[data-assembly-add]',
    cap: '[data-assembly-cap]'
  };

  function addonFor(form) {
    var addon = form && form.querySelector(selectors.addon);
    if (!addon || addon.hidden) return null;
    var box = addon.querySelector(selectors.checkbox);
    return box && box.checked ? addon : null;
  }

  // Called from theme.AjaxProduct.addItemFromForm. Returns a JSON body for
  // /cart/add.js when assembly is requested, otherwise null (normal add).
  function payload(form) {
    var addon = addonFor(form);
    if (!addon) return null;

    var params = new URLSearchParams(theme.utils.serialize(form));
    var bike = { id: Number(params.get('id')), quantity: Number(params.get('quantity') || 1) };
    var properties = {};
    params.forEach(function(value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) bike.properties = properties;
    if (params.get('selling_plan')) bike.selling_plan = Number(params.get('selling_plan'));

    return {
      items: [
        bike,
        { id: Number(addon.dataset.assemblyVariantId), quantity: bike.quantity }
      ]
    };
  }

  function syncVariant(evt) {
    var variant = evt.detail && evt.detail.variant;
    document.querySelectorAll(selectors.addon).forEach(function(addon) {
      var isFullBike = !!variant && addon.dataset.fullBikeVariants.indexOf(',' + variant.id + ',') !== -1;
      addon.hidden = !isFullBike;
      if (!isFullBike) addon.querySelector(selectors.checkbox).checked = false;
    });
  }

  function refreshCart() {
    if (document.body.classList.contains('template-cart')) {
      location.reload();
    } else {
      document.dispatchEvent(new CustomEvent('cart:build'));
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function(response) { return response.json(); });
  }

  function onCartAddClick(evt) {
    var btn = evt.target.closest(selectors.cartAdd);
    if (!btn) return;
    evt.preventDefault();
    btn.disabled = true;
    postJSON(theme.routes.cartAdd, {
      items: [{ id: Number(btn.dataset.assemblyAdd), quantity: Number(btn.dataset.quantity) }]
    }).then(refreshCart, function() { btn.disabled = false; });
  }

  var capping = false;
  function enforceCaps() {
    var marker = document.querySelector(selectors.cap);
    if (!marker || capping) return;
    capping = true;
    postJSON(theme.routes.cartChange, { id: marker.dataset.key, quantity: Number(marker.dataset.cap) })
      .then(function() { capping = false; refreshCart(); }, function() { capping = false; });
  }

  window.CinelliAssembly = { payload: payload, enforceCaps: enforceCaps };

  // "How factory assembly works" popup: move it out of the product column
  // (sticky/transformed ancestors break position: fixed), then use the
  // theme's modal so it looks and behaves like the other popups.
  function initInfoModal() {
    var modal = document.querySelector('[data-assembly-info-modal]');
    if (!modal || !window.theme || !theme.Modals) return;
    document.body.appendChild(modal);
    new theme.Modals('AssemblyInfoModal', 'assembly-info');
  }

  document.addEventListener('variant:change', syncVariant);
  document.addEventListener('DOMContentLoaded', initInfoModal);
  document.addEventListener('click', onCartAddClick);
  document.addEventListener('cart:rendered', enforceCaps);
  document.addEventListener('DOMContentLoaded', enforceCaps);
})();
